import React, { useEffect, useState } from "react";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  POST_GetDepartmentDropDownList,
  POST_ProductGroupDropDownListByDepartmentID,
  POST_ReferenceStandardInsert,
} from "../../../helpers/url_helper";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

import { post, postFormData } from "../../../helpers/api_helper";
import { Spin } from "antd";
import { SVGICON } from "../../../constant/theme";
import { errorMessage, warningMessage } from "../CommonFunctions";

const QuickAddReferenceStandard = ({
  departmentID,
  productGroupID,
  showModal,
  setShowModal,
  fnCallback,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const [productGroupOptions, setProductGroupOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [referenceStandardDocFile, setReferenceStandardDocFile] =
    useState(null);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    ReferenceStandard: Yup.string()
      .trim()
      .required("Reference Standard is required field"),
    DepartmentID: Yup.string().trim().required("Department is required field"),
    ProductGroupID: Yup.string()
      .trim()
      .required("Material Group is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ReferenceStandardIDEncrypt: "",
      ReferenceStandard: "",
      Description: "",
      ProductGroupID: productGroupID,
      DepartmentID: departmentID,
      DepartmentName: "",
      ProductGroupName: "",
      ReferenceDocFilePath: "",
      ReferenceDocFilePathURL: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { DepartmentID, ReferenceDocFilePath, ReferenceDocFilePathURL },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    // let payload = {
    //   ...values,
    //   DepartmentIDEncrypt: departmentID,
    //   ProductGroupIDEncrypt: productGroupID,
    //   CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
    //   CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
    //     ? AuthUser?.ReferenceIDEncrypt
    //     : "0",
    //   ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
    //     ? AuthUser?.ReferenceIDEncrypt
    //     : "0",
    // };

    let formData = new FormData();

    formData.append(
      "ReferenceStandardIDEncrypt",
      values?.ReferenceStandardIDEncrypt
    );

    formData.append("ProductGroupIDs", productGroupID);
    formData.append("DepartmentIDs", departmentID);
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);

    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
    );

    formData.append("ReferenceStandard", values?.ReferenceStandard.trim());
    formData.append("Description", values?.Description);

    formData.append("ReferenceDocFilePathURL", values?.ReferenceDocFilePathURL);
    formData.append("ReferenceDocFilePath", referenceStandardDocFile);

    postFormData(POST_ReferenceStandardInsert, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          fnCallback(response?.EncryptID, values.ReferenceStandard.trim());
          formik.resetForm();
          setShowModal(false);
          setIsLoading(false);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getDepartmentList();
  }, []);

  useEffect(() => {
    if (showModal == true) {
      formik.setFieldValue("DepartmentID", departmentID);
      formik.setFieldValue("ProductGroupID", productGroupID);
    }
  }, [showModal]);

  const getDepartmentList = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            }))
          );

          //   /*select the value when there is only one option while insert only*/
          //   if (response?.List?.length == 1) {
          //     formik.setFieldValue(
          //       "DepartmentID",
          //       response?.List[0].DepartmentIDEncrypted
          //     );
          //   }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (DepartmentID) {
      formik.setFieldValue(
        "DepartmentName",
        departmentOptions?.filter((x) => x.value == departmentID)[0]?.label
      );
      getProductGroupDDL(DepartmentID);
    } else {
      setProductGroupOptions([]);
      // formik.setFieldValue("ProductGroupID", "");
    }
  }, [DepartmentID]);

  const getProductGroupDDL = (DepartmentID) => {
    setIsLoading(true);
    post(POST_ProductGroupDropDownListByDepartmentID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      DepartmentIDEncrypt: DepartmentID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProductGroupOptions(
            response?.ProductGroupDropDownList?.map((item) => ({
              label: item.ProductGroupName,
              value: item.ProductGroupIDEncrypt,
            }))
          );
          formik.setFieldValue(
            "ProductGroupName",
            response?.ProductGroupDropDownList?.filter(
              (x) => x.ProductGroupIDEncrypt == productGroupID
            )[0]?.ProductGroupName
          );
          //   /*select the value when there is only one option while insert only*/
          //   if (response?.ProductGroupDropDownList?.length == 1) {
          //     formik.setFieldValue(
          //       "ProductGroupID",
          //       response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt
          //     );
          //   }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadReferenceStandardDocFile = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /(doc|docx|pdf)$/;

      var validPdfSize = true;
      var validFileFormat = true;
      // alert(file.type.match(pattern));
      //if (!file.type.match(pattern)) {
      if (
        !file.type.match("pdf") &&
        !file.type.match("doc") &&
        !file.type.match("docx")
      ) {
        validFileFormat = false;
        setReferenceStandardDocFile(null);

        warningMessage("Select valid Doc/PDF file!");
      } else {
        if (Math.round(file.size / 1024 / 1024) > 20) {
          validPdfSize = false;
        }
        // }
      }

      if (validFileFormat && validPdfSize) {
        setReferenceStandardDocFile(file);
      } else {
        e.target.value = [];
        if (!validPdfSize) {
          // swal("", "Doc/Pdf file should not be more than 1 MB!", "warning");
          warningMessage("Doc/Pdf file should not be more than 20 MB!");
          setReferenceStandardDocFile(null);
        }
      }
    }
  };

  return (
    <Modal className="fade" show={showModal} onHide={setShowModal}>
      <Spin
        size="large"
        spinning={isLoading}
        tip={"Loading..."}
        style={{ position: "fixed" }}
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Header>
              <Modal.Title>Reference Standard</Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => {
                  formik.resetForm();
                  setShowModal(false);
                }}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <Field
                    label="Reference Standard"
                    name="ReferenceStandard"
                    placeholder={"Enter Reference Standard"}
                    component={CustomInput}
                    required
                    maxLength={100}
                    autoFocus
                  />
                </Col>

                <Col lg={12}>
                  {/* <Field
                    label="Department"
                    name="DepartmentID"
                    placeholder={"Select Department"}
                    component={CustomSelect}
                    options={departmentOptions}
                    required
                  /> */}
                  <Field
                    label="Department"
                    name="DepartmentName"
                    component={CustomInput}
                    disabled={true}
                    required
                  />
                </Col>

                <Col lg={12}>
                  {/* <Field
                    label="Material Group"
                    name="ProductGroupID"
                    placeholder={"Select Material Group"}
                    component={CustomSelect}
                    options={productGroupOptions}
                    required
                  /> */}
                  <Field
                    label="Material Group"
                    name="ProductGroupName"
                    component={CustomInput}
                    disabled={true}
                    required
                  />
                </Col>
                <Col lg={12}>
                  <div className="d-flex justify-content-between">
                    <label className="mb-1">Reference Standard File </label>
                    {ReferenceDocFilePath ? (
                      <Link
                        to="#"
                        title="Download"
                        className="fs-14"
                        onClick={() => {
                          window.open(ReferenceDocFilePath, "_blank");
                        }}
                      >
                        {SVGICON.Download}
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                  <input
                    type="file"
                    id="fileUpload"
                    className="form-control form-control-sm"
                    accept=".doc,.docx,application/pdf"
                    onChange={uploadReferenceStandardDocFile}
                  />
                  <label htmlFor="fileUpload" name=""></label>
                </Col>

                <Col lg={12}>
                  <Field
                    label="Description"
                    name="Description"
                    placeholder={"Enter Description"}
                    component={CustomTextArea}
                    rows={5}
                    maxLength={500}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                //  variant="primary"
                variant="primary btn-sm"
                type="submit"
              >
                <i className="fa-solid fa-floppy-disk"></i> Submit
              </Button>
              <Button
                // variant="danger light"
                variant="danger btn-sm"
                onClick={() => {
                  formik.resetForm();
                  setShowModal(false);
                }}
              >
                <i className="fa fa-cancel"></i> Cancel
              </Button>
            </Modal.Footer>
          </Form>
        </FormikProvider>
      </Spin>
    </Modal>
  );
};

export default QuickAddReferenceStandard;
